import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationFacade } from '@core/facades/notification.facade';
import { MutualFundService } from '@core/services/mutual-fund.service';
import { ButtonDirective } from '@shared/directives/button.directive';
import { InputLabelComponent } from '@shared/ui/input-label/input-label.component';
import { SlideInRightModalComponent } from '@shared/ui/slide-in-right-modal/slide-in-right-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-update-mfd-distribution',
  standalone: true,
  imports: [
    SlideInRightModalComponent,
    InputLabelComponent,
    FormsModule,
    CommonModule,
    ButtonDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './update-mfd-distribution.component.html',
  styleUrl: './update-mfd-distribution.component.scss',
})
export class UpdateMfdDistributionComponent implements OnInit, OnDestroy {
  fb = inject(FormBuilder);
  mutualFundService = inject(MutualFundService)
  change = inject(ChangeDetectorRef)
  toast = inject(NotificationFacade)

  isLoading: boolean = false;
  subs: Subscription[] = [];

  dateRangeForm = this.fb.nonNullable.group({
    end_date: [''],
    start_date: [''],
  });

  ngOnInit() {}

// seed client id then update distribution
  seedClientsId() {
    this.isLoading = true
    const sub = this.mutualFundService.seedClientsId().subscribe({
      next: (res) => {
       this.updateDistribution()
      },
      error: () => {
        this.updateDistribution()
      },
    });
    this.subs.push(sub);
  }


  updateDistribution() {
    const sub = this.mutualFundService.updateDistribution(this.dateRangeForm.getRawValue()).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.toast.success('Distribution Updated Sucessfully')
        this.change.detectChanges();
      },
      error: (err) => {
        this.isLoading = false;
        this.toast.error('Error while updating Distribution', err)
        this.change.detectChanges();
      },
    });

    this.subs.push(sub);
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
